import { ALL_JOB_SWMS_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getJobSwmsEmergencyProcedures = (abortController, swmsId, jobId) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.get(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/emergency-procedures`, { ...abortController })
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(res.data.data);
      }

      return Promise.reject(Strings.generic_error);
    })
    .catch((error) => Promise.reject(
      error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : Strings.network_error
    ));
};

export const saveJobSwmsEmergencyProcedures = (jobId, swmsId, proceduresPayload, version) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.put(
    `${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/emergency-procedures`,
    { version, document: { procedures: proceduresPayload } }
  ).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(
    error && error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : Strings.network_error
  ));
};
